import { useNostoAppState } from "@nosto/search-js/preact/hooks";

export default function NoResults() {
  const query = useNostoAppState((state) => state.response.query);
  const globalLanguage = window?.Bedrock?.language;
  return (
    <div className="plp__no-results">
      {query ? (
        <>
          <h6>
            {globalLanguage?.no_results_for || "No result for"} &apos;{query}
            &apos;
          </h6>
          <h5>Try modifying your search term.</h5>
        </>
      ) : (
        <div>No results found</div>
      )}
    </div>
  );
}
